import React from 'react'
 import useSEO from "./useSEO";

const Contact = () => {
  useSEO({ 
  title: "Contact Us | Get in Touch with Our Team",
  description: "Have questions or need assistance? Contact us today for professional support, inquiries, and service information. We're here to help you every step of the way.",
  keywords: "contact us, customer support, get in touch, business inquiries, service information, contact form, phone support, email support, client assistance",
  ogTitle: "Contact Us - We're Here to Help",
  ogDescription: "Reach out to our team for any questions, support, or business inquiries. We’re ready to assist you.",
  ogImage: "img/elegant-advisors-logo.png",
  twitterTitle: "Contact Us - We're Here to Help",
  twitterDescription: "Get in touch with us for professional support and information. We're always happy to assist you.",
  twitterImage: "img/elegant-advisors-logo.png"
});
  return (
    <div>

         <section className="position-relative overflow-hidden pb-0 pt-xl-9">
      {/* SVG decoration left */}
      <div className="position-absolute top-0 start-0 ms-n7 d-none d-xl-block">
        <img src="assets/images/elements/decoration-pattern.svg" alt="" />
      </div>

      {/* SVG decoration right */}
      <figure className="position-absolute top-0 end-0 me-n4 mt-n7 d-none d-xl-block">
        <svg
          className="fill-mode opacity-1"
          width="775px"
          height="834px"
          viewBox="0 0 775 834"
          style={{ enableBackground: "new 0 0 775 834" }}
          xmlns="http://www.w3.org/2000/svg"
          xmlSpace="preserve"
        >
          <path d="M486.1,564.4c..." />
          {/* Remaining <path> elements omitted for brevity */}
        </svg>
      </figure>

      <div className="container pt-4 pt-sm-5">
        <div className="row g-xl-5">
          {/* Hero content START */}
          <div className="col-xl-7 mb-5 mb-xl-0">
            <div className="pe-xxl-4">
              <span className="heading-color d-inline-block bg-light small rounded-3 px-3 py-2">
                Contact Us
              </span>
              <h1 className="mt-3 lh-base">
                Get in touch for more information
              </h1>

              <div className="col-md-6">
                <div className="card card-body p-4">
                  <h6 className="card-title mb-3">
                    <a href="#">Office Address</a>
                  </h6>
                  <ul className="list-group list-group-borderless border-0">
                    <li className="d-flex mb-3">
                      <i className="bi bi-geo-alt text-primary me-2"></i>
                      Trendz Eashan Arcade, Kavuri Hills, Telangana - 500033.
                    </li>
                    <li className="d-flex mb-3">
                      <i className="bi bi-send-check text-primary me-2"></i>
                      Email: ashok@elegantconsultings.com
                    </li>
                    <li className="d-flex mb-3">
                      <i className="bi bi-headset text-primary me-2"></i>
                      Call: +91 9550278055
                    </li>
                  </ul>
                </div>
              </div>

              <div className="d-sm-flex gap-3 align-items-center my-5">
                <h6 className="mb-3 mb-sm-0">Follow us on:</h6>
                <ul className="list-inline flex-wrap mb-0">
                  <li className="list-inline-item">
                    <a
                      href="https://www.facebook.com/profile.php?id=61579123201569"
                      className="btn btn-icon btn-light text-facebook rounded-circle"
                    >
                      <i className="bi bi-facebook"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.instagram.com/eleconsultings/"
                      className="btn btn-icon btn-light text-instagram rounded-circle"
                    >
                      <i className="bi bi-instagram"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.linkedin.com/in/elegant-consultings-471032379/"
                      className="btn btn-icon btn-light text-linkedin rounded-circle"
                    >
                      <i className="bi bi-linkedin"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://x.com/eleconsultings/"
                      className="btn btn-icon btn-light text-twitter rounded-circle"
                    >
                      <i className="bi bi-twitter"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.youtube.com/@eleconsultings"
                      className="btn btn-icon btn-light text-youtube rounded-circle"
                    >
                      <i className="bi bi-youtube"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.threads.com/@eleconsultings"
                      className="btn btn-icon btn-light text-youtube rounded-circle"
                    >
                      <i className="bi bi-threads"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Hero image & form START */}
          <div className="col-md-10 col-xl-5 position-relative mx-auto mt-7 mt-xl-0">
            <div className="card card-body shadow border p-sm-5">
              <form className="row g-4">
                <div className="col-md-6">
                  <label className="form-label heading-color">Your name *</label>
                  <input type="text" className="form-control form-control-lg" placeholder="Full name" />
                </div>
                <div className="col-md-6">
                  <label className="form-label heading-color">Email address *</label>
                  <input type="email" className="form-control form-control-lg" placeholder="name@gamil.com" />
                </div>
                <div className="col-md-6">
                  <label className="form-label heading-color">Phone number *</label>
                  <input type="text" className="form-control form-control-lg" placeholder="919123456789" />
                </div>
                <div className="col-md-6">
                  <label className="form-label heading-color">Company *</label>
                  <input type="text" className="form-control form-control-lg" placeholder="Company name" />
                </div>
                <div className="col-12">
                  <label className="form-label heading-color">Message *</label>
                  <textarea className="form-control" placeholder="Write your message here...." style={{ height: 150 }}></textarea>
                </div>
                <button className="btn btn-lg btn-primary mb-0">Send a message</button>
              </form>
            </div>
          </div>
          {/* Hero image & form END */}
        </div>
      </div>
    </section>
      
    </div>
  )
}

export default Contact
